<script>
import DibbleTranslation from "../../translation/translation";
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";
import UpComingEvents from '../Boat/UpComingEvents'
import RentalReportModal from "./ReportModal/RentalReportModal";
import { ENABLE_MAP_EVENT, EventBus } from "../../utils/event-bus";


export default {
    name: "Rental",
    display: "Transition",
    components: { UpComingEvents, RentalReportModal },
    data() {
        return {
            userAuth: null,
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            boats: [],
            rentalBoatTypes: {},
            rentalBoatStatuses: {},
            isShowReportModal: false,
            queryStr: "",
            restrictionMaps: [],
            selectedRestrictionId: ''
        };
    },
    created() {
        this.getRentalBoatTypes();
        this.getAdminBoats();
        this.getRestrictionMaps();
        this.userAuth = this.$cookies.get('_user');
    },
    mounted() {
        this.dibbleJs.showLoader();
    },
    methods: {
        searchForOrders() {
            if (this.queryStr) {
                this.dibbleJs.showLoader();
                const params = {
                    request: DibbleApi.api.getRentalBoatOrdersHistory,
                    search_string: this.queryStr
                };
                this.dibbleJs.callApiRequest(params, response => {
                    this.dibbleJs.hideLoader()
                    if (DibbleApi.isResponseSuccess(response)) {
                        const orders = response['orders']
                        if (orders.length) {
                            if (orders.length === 1) {
                                this.$router.push(`/rental-order/${orders[0].order_id}`);
                            } else {
                                this.$router.push(`/rental-order/search/${this.queryStr}`);
                            }
                        } else {
                            this.dibbleJs.toastErrorMessage('There is no record matched your query.')
                        }
                    } else {
                        this.dibbleJs.toastErrorMessage(response.message)
                    }
                });
            }
        },
        getAdminBoats() {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getRentalBoatsInfo,
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                const { boat_types, rental_boat_statuses } = response;
                this.boats = boat_types;
                this.rentalBoatStatuses = rental_boat_statuses;
            }
        },
        getRentalBoatTypes() {
            const params = {
                request: DibbleApi.api.getRentalBoatTypes,
            };
            this.dibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    response?.boat_types.forEach((element) => {
                        this.rentalBoatTypes[element.boat_type] = element.name;
                    });
                    if (response?.enable_map) {
                        EventBus.$emit(ENABLE_MAP_EVENT)
                    }
                }
            });
        },
        getRestrictionMaps() {
            const params = {
                request: DibbleApi.api.getRestrictionMaps,
                token: DibbleJS.getStorageToken()
            }
            this.dibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.restrictionMaps = response.maps
                    const selectedRestriction = response.maps.find(el => el.is_active)
                    if (selectedRestriction) {
                        this.selectedRestrictionId = selectedRestriction.id
                    }
                }
            });
        },
        handleClick(type) {
            this.$router.push(`/boat-type-info/${type}`);
        },
        toggleReportModal() {
            this.isShowReportModal = !this.isShowReportModal
        },
        goToPageRentalDays() {
            this.$router.push('/no-rental-days')
        },
        changeRestriction(e) {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.setActiveRestrictionMaps,
                token: DibbleJS.getStorageToken(),
                map_id: e.target.value
            }
            this.dibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.dibbleJs.hideLoader();
                }
            })
        }
    }
};
</script>
<template src="./template/index.html"></template>
<style lang="scss" scoped>
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
    background: #ECEFF1;
    background-image: none;
    flex: 1;
    padding: 0 .5em;
    color: #000;
    cursor: pointer;
    font-size: 1em;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
}

select::-ms-expand {
    display: none;
}

.select {
    position: relative;
    display: flex;
    width: 150px;
    height: 3em;
    line-height: 3;
    background: #5c6664;
    overflow: hidden;
    border-radius: .25em;
}

.select::after {
    content: '\25BC';
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1em;
    background: #333;
    cursor: pointer;
    pointer-events: none;
    transition: .25s all ease;
    color: #ccc;
}

.select:hover::after {
    color: #fff;
}

.content-rental {
    display: flex;
    padding: 20px 30px;
    flex-direction: row;
    justify-content: space-between;
    min-width: 1000px;

    .first-session {
        width: 65%;
        display: flex;
        flex-direction: column;

        .list-btn-option {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .btn-option {
                padding: 15px 30px;
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                text-align: center;
                color: #FFFFFF;
                background: #2C94AB;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 100px;
                text-decoration: none;
            }
        }

        .list-boat {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .boat-info {
                width: 45%;
                height: 280px;
                display: flex;
                flex-direction: column;
                cursor: pointer;
                box-shadow: 0px 18px 29px -1px rgba(0,0,0,0.39);
                -webkit-box-shadow: 0px 18px 29px -1px rgba(0,0,0,0.39);
                -moz-box-shadow: 0px 18px 29px -1px rgba(0,0,0,0.39);
                background: transparent;
                border-radius: 40px;
                margin-bottom: 50px;


                .boat-header {
                    height: 190px;
                    background-position: center;
                    background-size: cover;
                    border-top-right-radius: 40px;

                    .boat-title {
                        width: 90%;
                        height: 43px;
                        background: #1C5169;
                        opacity: 0.8;
                        box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                        border-radius: 0px 25px 25px 0px;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 22px;
                        color: #FFFFFF;
                        padding-left: 20px;


                        strong {
                            font-weight: 700;
                            font-size: 30px;
                            line-height: 41px;
                            letter-spacing: -2px;
                            color: #52B9D0;
                            padding-right: 10px;
                        }
                    }
                }

                .boat-bottom {
                    flex: 1;
                    padding: 5px 0px;
                    display: flex;
                    flex-wrap: wrap;
                    background: #C2D8DD;
                    border-bottom-right-radius: 40px;

                    .boat-statistic {
                        width: calc(100% / 3);
                        display: flex;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 22px;
                        justify-content: center;
                        align-items: center;

                        &:not(:nth-last-child(-n+2)) {
                            border-bottom: 1px solid #fff
                        }

                        .num-statistic {
                            color: #2C94AB;
                        }

                        .text-statistic {
                            color: #555E67;
                            padding-left: 5px;
                        }
                    }
                }
            }
        }
    }

    .second-session {
        width: 30%;
    }

    @media only screen and (max-width: 1360px) {
        .btn-option {
            padding: 10px 15px !important;
        }
    }
}
</style>
